import { z } from "zod"

/**
 * @description
 *	The schema of {@link Timestamp} type.
 */
export const TimestampSchema = z.union([
	z.coerce.date(),
	z
		.string()
		.datetime()
		.transform(datetime => new Date(datetime))
])

/**
 * @description
 *	A timestamp.
 */
export type Timestamp = z.infer<typeof TimestampSchema>
